<template>
    <vs-popup class="add-new-incoterms" id="popup" title="EMAIL ACTIVITY REPORT" @close="open = false" :active.sync="open"
        :buttons-hidden="true">
        <vx-card no-shadow>
            <vs-table :data="data_list">

                <template slot="thead">
                    <vs-th width="70%">EMAIL ADDRESS</vs-th>
                    <vs-th width="30%">ACTIVITY COUNT</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].email_address">
                            {{ data[indextr].email_address }}
                        </vs-td>

                        <vs-td>
                            {{ data[indextr].activity.length }}
                        </vs-td>


                        <template class="expand-user" slot="expand">
                            <div class="con-expand-users w-4/5">
                                <vs-table :data="tr.activity">

                                    <template slot="thead">
                                        <vs-th width="15%">ACTIVITY TYPE</vs-th>
                                        <vs-th width="15%">DATE/TIME</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                            <vs-td :data="data[indextr].action">
                                                {{ data[indextr].action }}
                                            </vs-td>
                                            <vs-td :data="data[indextr].timestamp">
                                                {{ __dateTimeFormatter(data[indextr].timestamp) }}
                                            </vs-td>

                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </template>

                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        id: '',
        customer_id: null,
        data_list: [],
    }
}

export default {
    name: 'ViewCampaignEmailActivityReportPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id, customer_id = '') {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
                this.id = id
                this.customer_id = customer_id
                this.data_list = []
                await this.fetchBantData()
            } catch (error) {

            }
        },
        async fetchBantData() {
            try {
                const { data } = await CrmRepository.getCampaignEmailActivityReport(this.id, this.customer_id)
                this.data_list = data.emails
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /* min-height: 30% !important; */
    min-width: 30% !important;
}
</style>
  